export enum ExecutionType {
  CUSTOM = 'CUSTOM',
  CROSS_BROWSER = 'CROSS_BROWSER',
}

enum ExecutionTypeMapping {
  'CUSTOM' = 'Custom',
  'CROSS_BROWSER' = 'Cross browser',
}

enum ExecutionEntityType {
  ADHOC_EXECUTION = 'ADHOC_EXECUTION',
}